module.exports = __webpack_public_path__ + "static/05-ce60179ccc2e29bfb46239a69fb55ab8.jpg";